import Box from '@mui/material/Box'
import React from 'react'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import DoubleAccordion from '../components/Accordions/DoubleAccordion'
import Cards from '../components/Cards/Cards'
import TextBtnSection from '../components/Section/TextBtnSection'
import { useTranslation } from '../hook/Translation'
import InstagramEmbed from '../components/instagram/InstagramEmbed'

export default function ElementalAlchemy() {
const { t } = useTranslation();
    // const accodirons = [
    //     {
    //         title: 'What it is?',
    //         content: 'This ritual begins with a calming foot soak infused with Himalayan salts and essential oils to ground you. Once on the massage table, you’ll experience a blend of massage techniques drawn from around the world: rhythmic Balinese-style strokes to ease muscle tension, gentle Hawaiian Lomi-Lomi waves for deep relaxation, and maybe some Thai stretching for energy flow. Warm aromatherapy oils a signature blend exclusive to RINU, perhaps with notes of frankincense, lavender, and citrus are used generously, cocooning your skin in moisture and your senses in a subtle fragrance. Hot stones may be placed on key points along your spine and chakra areas, their soothing heat penetrating deeply to melt away knots. Throughout,',
    //         content2: 'your therapist tunes the pressure to your preference, ensuring therapeutic relief (knots worked out from head, neck, shoulders) while never disrupting the meditative tranquility. The RINU Ritual often includes a brief scalp massage and foot reflexology segment, truly covering you from crown to toe. A soft chime or Tibetan singing bowl might gently ring at the conclusion, bringing you back to awareness.'
    //     },
    //     {
    //         title: 'How it works',
    //         content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation',
    //         content2: 'your therapist tunes the pressure to your preference, ensuring therapeutic relief (knots worked out from head, neck, shoulders) while never disrupting the meditative tranquility. The RINU Ritual often includes a brief scalp massage and foot reflexology segment, truly covering you from crown to toe. A soft chime or Tibetan singing bowl might gently ring at the conclusion, bringing you back to awareness.'
    //     },
    // ]

   

    return (
        <Box pb={'50px'}>
            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/05/img_6a0726ec34ab07.88034967.jpeg`} alt='Elemental-Alchemy' loading='lazy' height={1} width={1} className="fitCover" />
                        {/* <InstagramEmbed videoId={'DSaXOQpCH4x'} /> */}
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: t('elemental_alchemy.mainTitle'),
                        description: t('elemental_alchemy.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e St.Barth ChillOut")}`,
                        learn: "",
                        price: `${t('price_session')} €75 - 60min`
                    }}
                />
            </Box>
            
            {/* <Grid container gap={{md: '80px', xs: '50px'}} className='generalContainer' sx={{ marginX: 'auto',  }} marginTop={{md: '123px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <DoubleAccordion data={accodirons} />
                </Grid>
            </Grid>

            <Grid container gap={{md: '40px', xs: '20px'}} sx={{ marginX: 'auto',  }} className='generalContainer' marginTop={{md: '134px', xs: '50px'}} mb={{md: '193px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600}>Treatment Areas</Typography>
                    <Typography textAlign={'center'} fontWeight={600} marginX={'auto'} width={{md: '80%', xs: '100%'}} marginTop={'22px'} variant="body1" color="text.secondary" fontSize={'1rem'}>Most often done on the face, jawline, and neck for anti-aging and scar revision, but also effective on certain body areas (such asacne-scarred shoulders or stretch marks on abdomen/thighs).</Typography>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} />
                </Grid>
            </Grid> */}
        </Box>
    )
}